module.exports = __webpack_public_path__ + "static/media/username.dae893ff.svg";